import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, PLATFORM_ID, ViewChild } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { faFacebookF, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import ClipboardJS from 'clipboard';
import { MatTooltip } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';
import { unsubscribe } from '../../../utils/helpers';
import { IndicatorsService } from '../indicators.service';

@Component({
  standalone: false,
  selector: 'social-buttons',
  template: `
    <div class="d-flex">
      <button type="button" class="social-button" #cc [attr.data-clipboard-text]="url" [matTooltip]="ccText | translate" aria-label="connection link">
        <fa-icon [icon]="icons.cc"></fa-icon>
      </button>
      <button type="button" (click)="shareOnFacebook()" class="social-button" aria-label="facebook">
        <fa-icon [icon]="icons.fb"></fa-icon>
      </button>
      <button type="button" (click)="tweet()" class="social-button" aria-label="x">
        <fa-icon [icon]="icons.twitter"></fa-icon>
      </button>
      <button type="button" (click)="shareOnLinkedIn()" class="social-button" aria-label="linkedin">
        <fa-icon [icon]="icons.linkedIn"></fa-icon>
      </button>
    </div>
  `,
  styleUrls: [`./social-buttons.component.scss`]
})
export class SocialButtonsComponent implements AfterViewInit, OnDestroy {
  private readonly subscriptions: Subscription[] = [];
  private clipBoard: any;
  private readonly isBrowser: boolean;

  @ViewChild(MatTooltip) tooltip: MatTooltip;
  @ViewChild('cc', { static: true })
  private ccElement: ElementRef;

  url: string;
  ccText = 'general.copy';

  readonly icons: any = {
    fb: faFacebookF,
    twitter: faTwitter,
    linkedIn: faLinkedin,
    cc: faLink,
  };

  constructor(
    private readonly indicatorService: IndicatorsService,
    @Inject(PLATFORM_ID) platformId: object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    unsubscribe(this.subscriptions);

    if (this.isBrowser) {
      this.subscriptions.push(
        this.indicatorService.valueChanges.subscribe((val: Record<string, any>) => {
          const url = window.location.href + '?' + new HttpParams({ fromObject: val as any }).toString();
          this.url = url;
        }),
      );
    }
  }

  ngAfterViewInit() {
    if (!this.isBrowser || !this.ccElement) {
      return;
    }

    this.clipBoard = new ClipboardJS(this.ccElement.nativeElement);
    this.clipBoard.on('success', () => {
      this.ccText = 'general.copied';
      this.tooltip.show();
      setTimeout(() => {
        this.ccText = 'general.copy';
      }, 3000);
    });
  }

  ngOnDestroy() {
    unsubscribe(this.subscriptions);
    if (this.clipBoard) {
      this.clipBoard.destroy();
    }
  }

  shareOnFacebook() {
    if (!this.isBrowser) {
      return;
    }
    const url = 'https://www.facebook.com/bipt.ibpt/';
    const newwindow = window.open(url, 'name', 'height=500,width=520,top=200,left=300,resizable');
    if (window.focus) {
      newwindow.focus();
    }
  }

  tweet() {
    if (!this.isBrowser) {
      return;
    }
    const url = 'https://twitter.com/bipt_ibpt';
    const newwindow = window.open(url, 'name', 'height=500,width=520,top=200,left=300,resizable');
    if (window.focus) {
      newwindow.focus();
    }
  }

  shareOnLinkedIn() {
    if (!this.isBrowser) {
      return;
    }
    const url = 'https://www.linkedin.com/company/bipt/';
    const newwindow = window.open(url, 'name', 'height=500,width=520,top=200,left=300,resizable');
    if (window.focus) {
      newwindow.focus();
    }
  }
}